import SectionProvider from '@builder/sections/SectionProvider'
import moment from 'moment'

export const name = 'Time Item 3'
export const group = 'time'
export const defaultOptions = {
  content: {
    time: {
      type: 'time-mod',
      display: true,
      time: moment(moment().format('YYYY-MM-DD') + ' ' + '23:59').valueOf(),
      size: .8,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      sizing: {
        width: 6,
        counter: 3.5,
        divider: 1.5,
        subtitle: 1
      }
    }
  },
  customize: {
    layouts: null,
    style: {
      background: {
        background: '#f5f5f5',
        type: 'background-customs'
      },
      color: {
        type: 'color-customs',
        color: '#0C226C'
      },
      colorSubtitle: {
        color: '#aeb1b4',
        type: 'color-customs',
        label: 'Subtitle color'
      },
      dontShow: {
        type: 'checklist-customs',
        label: 'Don\'t Show',
        value: [],
        items: ['Days', 'Hours', 'Minutes', 'Seconds']
      },
      container: {
        type: 'container-customs',
        container: null
      },
      backgroundImage: {
        type: 'background-image-customs',
        src: null,
        position: 'center',
        size: 'cover',
        opacity: 1
      },
      padding: {
        type: 'height-customs',
        sm: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        },
        md: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        },
        lg: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        }
      }
    }
  }
}

export const previews = {
  left: null,
  right: null,
  main: require('@builder/assets/svg/previews/time/main-3.png')
}

export default class Section extends SectionProvider {
  constructor (options = {}) {
    super('TimeItem3', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
